export const APP_NAME_HEAD = 'LMS MindChamps';

export const APP_NAME = 'EDUTEK';

export const PATH_LOGO = '/images/home/champLMS-logo.png';

export const METHOD_COMPLETE = {
  checkbox: 'CHECKBOX',
  question: 'QUESTION',
  time: 'TIME',
  adaptiveForm: 'ADAPTIVE_FORM',
  adaptiveLearning: 'ADAPTIVE_LEARNING',
  instructorAccept: 'INSTRUCTOR_ACCEPT',
  uploadingAnswer: 'UPLOADING_ANSWER',
  AIAccept: 'AI_ACCEPT',
};

export const LIMIT_DEFAULT = 50;
export const LIMIT_MAX = 150;

export const LIMIT_AUDIENCE = 50;

export const LIMIT_COURSES_LEARNER = 50;

export const LIMIT_AUTOCOMPLETE = 25;

export const LIMIT_GET_LIST = 12;

export const LIMIT_DETAILPAGE_LIST = 10;

export const UNIT_TYPE = {
  CONTENT: 'CONTENT',
  WEBPAGE: 'WEBPAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PRESENTATION: 'DOCUMENT',
  SCORM: 'SCORM',
  IFRAME: 'IFRAME',
  LTI: 'LTI',
  TEST: 'TEST',
  SURVEY: 'SURVEY',
  ASSIGNMENT: 'ASSIGNMENT',
  LIVESTREAMING: 'LIVESTREAMING',
  MSTEAMS_MEETING: 'MSTEAMS_MEETING',
  LINK: 'LINK',
  SECTION: 'SECTION',
  CLASSROOM: 'CLASSROOM',
  FILES: 'FILES',
  SUBMISSION: 'SUBMISSION',
  LIVEANDPHYSICALCLASS: 'LIVEANDPHYSICALCLASS',
  UNIT: 'UNIT',
  DEFAULTLESSON: 'DEFAULTLESSON',
  GROUP: 'GROUP',
  UNITSECTION: 'UNITSECTION',
  SUBSECTION: 'SUBSECTION',
  SUB_SECTION: 'SUB_SECTION',
  LESSON: 'LESSON',
  AVATAR: 'AVATAR',
  CHATMESSAGE: 'CHATMESSAGE',
  CERTIFICATE: 'CERTIFICATE',
  SUBSECTION_LESSON: 'SUBSECTION_LESSON',
  SECTION_LESSON: 'SECTION_LESSON',
  UNIT_LESSON: 'UNIT_LESSON',
  ALL_LESSON: 'ALL_LESSON',
  COMBINE_CLASS: 'COMBINE_CLASS',
  // New lesson types
  ONLINE: 'ONLINE',
  PHYSICAL: 'PHYSICAL',
  ASYNCHRONOUS: 'ASYNCHRONOUS',
  EXAM: 'EXAM',
};

export const LESSONS_TYPE = [
  { label: 'LIVESTREAMING', value: 'LIVESTREAMING' },
  { label: 'MSTEAMS_MEETING', value: 'MSTEAMS_MEETING' },
  { label: 'CLASSROOM', value: 'CLASSROOM' },
  { label: 'VIDEO', value: 'VIDEO' },
  { label: 'AUDIO', value: 'AUDIO' },
  { label: 'FILES', value: 'FILES' },
  { label: 'PRESENTATION', value: 'DOCUMENT' },
  { label: 'SCORM', value: 'SCORM' },
  { label: 'CONTENT', value: 'CONTENT' },
  { label: 'IFRAME', value: 'IFRAME' },
  { label: 'LTI', value: 'LTI' },
  { label: 'TEST', value: 'TEST' },
  { label: 'ASSIGNMENT', value: 'ASSIGNMENT' },
  { label: 'SURVEY', value: 'SURVEY' },
  // New lesson types for enhanced functionality
  { label: 'ONLINE', value: 'ONLINE' },
  { label: 'PHYSICAL', value: 'PHYSICAL' },
  { label: 'ASYNCHRONOUS', value: 'ASYNCHRONOUS' },
  { label: 'EXAM', value: 'EXAM' },
];

// Lesson type categories for better organization
export const LESSON_TYPE_CATEGORIES = {
  DELIVERY_MODE: {
    ONLINE: 'ONLINE',
    PHYSICAL: 'PHYSICAL',
    ASYNCHRONOUS: 'ASYNCHRONOUS',
  },
  ASSESSMENT: {
    EXAM: 'EXAM',
    TEST: 'TEST',
    ASSIGNMENT: 'ASSIGNMENT',
    SURVEY: 'SURVEY',
  },
  CONTENT: {
    VIDEO: 'VIDEO',
    AUDIO: 'AUDIO',
    CONTENT: 'CONTENT',
    SCORM: 'SCORM',
    FILES: 'FILES',
    PRESENTATION: 'DOCUMENT',
    IFRAME: 'IFRAME',
    LTI: 'LTI',
  },
  INTERACTIVE: {
    LIVESTREAMING: 'LIVESTREAMING',
    MSTEAMS_MEETING: 'MSTEAMS_MEETING',
    CLASSROOM: 'CLASSROOM',
  },
};

export const QUESTION_TYPE = {
  MTC: 'MTC',
  FILLTHEGAP: 'FILLTHEGAP',
  ORDERING: 'ORDERING',
  FILLINTHEBLANK: 'FILLINTHEBLANK',
  DRAGDROP: 'DRAGDROP',
  FREETEXT: 'FREETEXT',
  RATING: 'RATING',
  SCALING: 'SCALING',
  RANDOMIZED: 'RANDOMIZED',
  ASSIGNMENT: 'ASSIGNMENT',
};

export const USER_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
  PERMANENTLY_DELETED: 'PERMANENTLY_DELETED',
};

export const USER_GROUP_TYPE = {
  USER: 'USER',
  CAPTAIN: 'CAPTAIN',
};

export const USER_FILE_TYPE = {
  ALL: 'ALL',
  CUSTOM: 'CUSTOM',
  COURSE_USER_GROUP: 'COURSE_USER_GROUP',
};

export const STATUS_FILES_UNIT = {
  EXPIRED: 'EXPIRED',
  UPCOMING: 'UPCOMING',
  PERMISSION: 'PERMISSION',
  APPROVED: 'APPROVED',
};

export const UNIT_STATUS_SUBMISSION = {
  USER: 'USER',
  GROUP: 'GROUP',
};
export const UNIT_STATUS_SUBMISSION_TYPE = {
  USER: 'USER',
  GROUP: 'LEADER',
};

export const SUBMISSION_TYPE = [
  {
    value: UNIT_STATUS_SUBMISSION.USER,
    label: 'User',
  },
  {
    value: UNIT_STATUS_SUBMISSION.GROUP,
    label: 'Group',
  },
];

export const UNIT_DATA_TYPE = {
  LINK: 'LINK',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  PRESENTATION: 'PRESENTATION',
  SCORM: 'SCORM',
};

export const UNIT_VIDEO_TYPE = {
  YOUTUBE: 'YOUTUBE',
  VIDEO: 'VIDEO',
  PRESENTATION: 'PRESENTATION',
};

export const TYPE_MEDIA = {
  FILE: 'FILE',
  LINK: 'LINK',
};

export const UNIT_STATUS = {
  COMPLETED: 'COMPLETED',
  PENDING: 'PENDING',
  FAILED: 'FAILED',
  RESET: 'RESET',
  RESUBMIT: 'RESUBMIT',
  NOSTARTED: 'Not Yet Started',
  INPROGRESS: 'In-Progress',
  REATTEMPT: 'REATTEMPT',
  REVIEW: 'REVIEW',
  NOT_ATTEMPT: 'NOT_ATTEMPT',
  ACTIVE: 'ACTIVE',
  INCOMPLETED: 'INCOMPLETED',
};

export const UNIT_STATUS_TOOL_TIP = {
  COMPLETED: 'Completed',
  GRADED: 'Graded',
  'In-Progress': 'In Progress',
  REATTEMPT: 'In Progress',
  FAILED: 'Not Passed',
  PENDING: 'Pending',
  'Not Yet Started': 'Not Yet Started',
  RESET: 'Not Yet Started',
  REVIEW: 'Submitted / Yet To Review',
  RESUBMIT: 'Not Yet Started',
  IN_PROGRESS: 'In Progress',
  INCOMPLETED: 'Incomplete',
};

export const UNIT_TYPE_COMPLETE = {
  TIME: 'TIME',
  CHECKBOX: 'CHECKBOX',
  QUESTION: 'QUESTION',
  UPLOADING_ANSWER: 'UPLOADING_ANSWER',
  INSTRUCTOR_ACCEPT: 'INSTRUCTOR_ACCEPT',
  AIAccept: 'AI_ACCEPT',
  ADAPTIVE_LEARNING: 'ADAPTIVE_LEARNING',
};

export const RecordState = {
  IDLE: 0,
  PREPARING: 1,
  RECORDING: 2,
};

export const USER_ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  INSTRUCTOR: 'INSTRUCTOR',
  LEARNER: 'LEARNER',
  CENTRE_ADMIN: 'CENTRE_ADMIN',
  CENTRE_BL: 'CENTRE_BL',
};

export const ATTEDANCE_STATUS = [
  { label: 'Present', value: 'PASSED' },
  { label: 'Absent', value: 'NOT_PASSED' },
];
export const ATTEDANCE_LIVE_STATUS = [
  { label: 'Present', value: 'JOINED' },
  { label: 'Absent', value: 'MISSING' },
];

export const USER_ROLES_TYPES = [
  { label: 'Super Admin', value: 'SUPER_ADMIN' },
  { label: 'Admin', value: 'ADMIN' },
  { label: 'Instructor', value: 'INSTRUCTOR' },
  { label: 'Learner', value: 'LEARNER' },
  { label: 'Centre BL', value: 'CENTRE_BL' },
];

export const USER_ROLE_NAMES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Administrator',
  INSTRUCTOR: 'Instructor',
  LEARNER: 'Learner',
  CENTRE_ADMIN: 'Centre Admin',
  CENTRE_BL: 'Centre BL',
};

export const QUESTION_ANSWER = {
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
};
export const USER_CLASS_STATUS = {
  COMPLETED: 'COMPLETED',
  ACTIVE: 'ACTIVE',
  IN_PROGRESS: 'IN_PROGRESS',
};
export const RESULT_STATUS_SELECT = [
  { label: 'Not Yet Started', value: 'NOTYETSTARTED' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Not Passed', value: 'FAILED' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Resubmit', value: 'RESUBMIT' },
  { label: 'Graded', value: 'GRADED' },
  { label: 'Reset', value: 'RESET' },
];
export const RESULT_STATUS = {
  COMPLETED: 'COMPLETED',
  NOTASSIGNED: 'NOT_ASSIGNED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  RESUBMIT: 'RESUBMIT',
  GRADED: 'GRADED',
  RESET: 'RESET',
  NOT_ATTEMPT: 'NOT_ATTEMPT',
  MARKED: 'MARKED',
  NOT_MARKED: 'NOT_MARKED',
};
export const COURSE_USER_STATUS = {
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
};

export const SECURITY_TYPE = {
  PASSWORD: 'PASSWORD',
  SNAPSHOT: 'SNAPSHOT',
};

export const STATUS_SUBMISSION = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  RESUBMIT: 'RESUBMIT',
  GRADED: 'GRADED',
  REATTEMPT: 'PENDING',
};

export const STATUS_SUBMISSION_LABEL = {
  GRADED: 'Graded',
  COMPLETED: 'Completed',
  FAILED: 'Not Passed',
  PENDING: 'Pending',
  RESUBMIT: 'Re-submit',
  RESET: 'Reset',
  REATTEMPT: 'Re-attempt',
};

export const FILE_SHARE_TYPE = {
  PRIVATE: 'PRIVATE',
  GROUP: 'GROUP',
  PUBLIC: 'PUBLIC',
  CUSTOM: 'CUSTOM',
};

// this is the real status
export const UNIT_STATUS_ADMIN = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
  DRAFT: 'DRAFT',
};

export const USER_EVENT_TYPE = {
  EVENT: 'EVENT',
  CLASSROOM: 'CLASSROOM',
  WEBINAR: 'WEBINAR',
  MSTEAMS_MEETING: 'MSTEAMS_MEETING',
};

export const SESSION_USER_GRADE_STATUS = {
  PASSED: 'PASSED',
  NOT_PASSED: 'NOT_PASSED',
  PENDING: 'PENDING',
};

export const SESSION_USER_GRADE_STATUS_LABEL = {
  PASSED: 'Passed',
  NOT_PASSED: 'Not passed',
  PENDING: 'Pending',
};

export const IMAGE_DIMENSION = {
  1920: '1920',
  1366: '1366',
  768: '768',
  320: '320',
  100: '100',
  root: 'root',
};

export const CHAT_GROUP_TYPE = {
  COURSE: 'COURSE',
  USER: 'USER',
};

export const TEMPLATE_IMPORT_USER = '/static/TemplateImportUser.xlsx';
export const TEMPLATE_IMPORT_GENERAL = '/static/TemplateImportUserCourse.xlsx';
export const TEMPLATE_WRAAPPED_CERTIFICATE = '/static/wrapped-certificate.json';
export const TEMPLATE_IMPORT_GENERAL_CENTRE =
  '/static/TemplateImportUserCourseCentre.xlsx';
export const NAME_FILE_EXPORT_GENERAL = 'ExportData';

export const DEFAULT_LANGUAGE = 'en';

export const DEFAULT_IMAGE = '/images/noimageavailable.png';
export const DEFAULT_IMAGE_ENCRPT = '/images/encrpted.jpg';
export const DEFAULT_CAROUSEL_IMAGE = '/images/Noclass.png';
export const DEFAULT_AVATAR = '/images/default-avatar.png';
export const DEFAULT_UPLOAD_IMAGE = '/images/uploadimage.png';

export const COURSE_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
};

export const USER_METHODS = {
  POST: 'POST',
  PUT: 'PUT',
  GET: 'GET',
  DELETE: 'DELETE',
};

export const EVENT_LIVE_TRAINING_STATUS = {
  LIVING: 'LIVING',
  STOP: 'STOP',
};

export const USER_ROOM_STATUS = {
  NEW: 'NEW',
  RUNNING: 'RUNNING',
  ENDED: 'END',
};

export const DISCOUNT_TYPE = [
  { label: 'percentage', value: 'PERCENTAGE' },
  { label: 'Amount', value: 'AMOUNT' },
];

export const MODE_OF_TRAINING = [
  { id: 1, name: 'Work-based/Workplace Learning' },
  { id: 2, name: 'Asynchronous E-Learning' },
  { id: 3, name: 'On the Job training' },
  { id: 4, name: 'Assessment' },
  { id: 5, name: 'Synchronous E-Learning' },
];
export const COURSE_RULES_AND_PATH_SHOW_UNITS = {
  IN_ANY_ORDER: 'IN_ANY_ORDER',
  IN_SEQUENTIAL_ORDER: 'IN_SEQUENTIAL_ORDER',
};

export const COURSE_RULES_AND_PATH_COMPLETED_WHEN = {
  ALL_UNITS_ARE_COMPLETED: 'ALL_UNITS_ARE_COMPLETED',
  A_PERCENTAGE_OF_UNIT_ARE_COMPLETED: 'A_PERCENTAGE_OF_UNIT_ARE_COMPLETED',
  SELECTED_UNITS_ARE_COMPLETED: 'SELECTED_UNITS_ARE_COMPLETED',
  SELECTED_TEST_IS_PASSED: 'SELECTED_TEST_IS_PASSED',
  SELECTED_QUIZ_AND_ASSIGNMENT: 'SELECTED_QUIZ_AND_ASSIGNMENT',
  SELECTED_GREAT_BOOK_CLASS: 'SELECTED_GREAT_BOOK_CLASS',
  SELECTED_GREAT_BOOK_CERTIFICATE: 'SELECTED_GREAT_BOOK_CERTIFICATE',
};

export const COURSE_RULES_AND_PATH_CALCULATE_SCORE_BY_AVERAGE_OF = {
  ALL_TESTS_AND_ASSIGNMENTS: 'ALL_TESTS_AND_ASSIGNMENTS',
  TESTS_ONLY: 'TESTS_ONLY',
  TESTS_AND_ASSIGNMENTS_CHOOSE: 'TESTS_AND_ASSIGNMENTS_CHOOSE',
};

export const COURSE_RULES_AND_PATH_NOTIFICATION_TYPE = {
  EMAIL_NOTIFICATION: 'EMAIL_NOTIFICATION',
  SMS_NOTIFICATION: 'SMS_NOTIFICATION',
  GRAPHICAL_ALERT: 'GRAPHICAL_ALERT',
};
export const COURSE_RULES_AND_PATH_NOTIFICATION_REMAINDER = {
  FIFTEEN_DAYS: 'FIFTEEN DAYS',
  TEN_DAYS: 'TEN DAYS',
  THREE_DAYS: 'THREE DAYS',
  ONE_HOUR: 'ONE HOUR',
  ONE_DAY: 'ONE DAY',
  THIRTY_MINUTES: 'THIRTY MINUTES',
  FIVE_MINUTES: 'FIVE MINUTES',
};
export const LIMIT_SIZE_FILE_UPLOAD = 500 * 1024 * 1024;
export const LIMIT_IMAGE_FILE_UPLOAD = 4 * 1024 * 1024;
export const LIMIT_CHAT_FILE_UPLOAD = 25 * 1024 * 1024;
export const ONEKILOBYTE = '1048576';

export const CALENDAR_COLOR = {
  EVENT: 'purple',
  WEBINAR: 'danger',
  CLASSROOM: 'info',
  MSTEAMS_MEETING: 'primary',
};

export const FILE_STATUS = {
  PRIVATE: 'PRIVATE',
  SHARE: 'SHARE',
};

export const SHOW_ANSWERS = {
  ALWAYS: 'ALWAYS',
  PASSED: 'PASSED',
};

export const AUDIENCE = {
  PRIVATE: 'PRIVATE',
  CUSTOM: 'CUSTOM',
  PUBLIC: 'PUBLIC',
};

export const SESSION_USER_ATTENDANCE = {
  JOINED: 'JOINED',
  MISSING: 'MISSING',
};

export const MODIFIERS_TIME = {
  setMaxHeight: {
    enabled: true,
    order: 890,
    fn: (data) => ({
      ...data,
      styles: {
        ...data.styles,
        overflow: 'auto',
        maxHeight: '300px',
      },
    }),
  },
};

export const SOCKET_DISCUSSION_EVENTS = {
  DISCUSSION: 'DISCUSSION',
  DISCUSSION_UPDATED: 'DISCUSSION_UPDATED',
  DISCUSSION_DELETED: 'DISCUSSION_DELETED',
};

export const SOCKET_NAMESPACE = {
  CHAT: '/chat',
  DISCUSSION: '/discussion',
  GROUP_CHAT: '/group-chat',
  LTI: '/lti',
  CLASSROOM_ATTENDANCE: '/classroom-attendance',
};

export const SOCKET_LTI_EVENTS = {
  LTI_DEEP_LINK_SELECTED: 'LTI_DEEP_LINK_SELECTED',
};

export const SOCKET_CLASSROOM_ATTENDANCE_EVENTS = {
  COUNT_UPDATED: 'CLASSROOM_ATTENDANCE_COUNT_UPDATED',
};

export const CONFERENCE_TYPE = {
  BBB: 'BBB',
  ZOOM: 'ZOOM',
};

export const ATTENDANCE_STATUS = {
  JOINED: 'Present',
  MISSING: 'Absent',
};

export const STATUS_SCORM = {
  incomplete: 'incomplete',
  completed: 'completed',
  passed: 'passed',
  failed: 'failed',
  browsed: 'browsed',
  'not attempted': 'not attempted',
};

export const OPTIONS_TIME_FLATPICKR = {
  enableTime: true,
  noCalendar: true,
  dateFormat: 'H:i',
  time_24hr: true,
};

export const NOTIFICATION_EVENT = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  REGISTRY_ACCOUNT: 'REGISTRY_ACCOUNT',
  DELETE_ACCOUNT: 'DELETE_ACCOUNT',
  ADD_TO_COURSE: 'ADD_TO_COURSE',
  ADD_TO_INTAKE: 'ADD_TO_INTAKE',
  ADD_TO_EVENT: 'ADD_TO_EVENT',
  REMOVE_TO_COURSE: 'REMOVE_TO_COURSE',
  REMOVE_TO_INTAKE: 'REMOVE_TO_INTAKE',
  REMOVE_TO_EVENT: 'REMOVE_TO_EVENT',
  COURSE_DELETED: 'COURSE_DELETED',
  INTAKE_DELETED: 'INTAKE_DELETED',
  EVENT_DELETED: 'EVENT_DELETED',
  EVENT_STARTED: 'EVENT_STARTED',
  USER_COMPLETED_COURSE: 'USER_COMPLETED_COURSE',
  USER_COMPLETED_TEST: 'USER_COMPLETED_TEST',
  USER_COMPLETED_SURVEY: 'USER_COMPLETED_SURVEY',
  USER_COMPLETED_ASSIGNMENT: 'USER_COMPLETED_ASSIGNMENT',
  INSTRUCTOR_GRADING: 'INSTRUCTOR_GRADING',
  ADD_DISCUSSION: 'ADD_DISCUSSION',
  REPLY_DISCUSSION: 'REPLY_DISCUSSION',
};

export const NOTIFICATION_EVENT_LABEL = {
  RESET_PASSWORD: 'Reset password',
  REGISTRY_ACCOUNT: 'Registry account',
  DELETE_ACCOUNT: 'Delete account',
  ADD_TO_COURSE: 'Add to course',
  ADD_TO_INTAKE: 'Add to intake',
  ADD_TO_EVENT: 'Add to event',
  REMOVE_TO_COURSE: 'Remove to course',
  REMOVE_TO_INTAKE: 'Remove to intake',
  REMOVE_TO_EVENT: 'Remove to event',
  COURSE_DELETED: 'Course deleted',
  INTAKE_DELETED: 'Intake deleted',
  EVENT_DELETED: 'Event deleted',
  EVENT_STARTED: 'Event started',
  USER_COMPLETED_COURSE: 'User completed course',
  USER_COMPLETED_TEST: 'User completed test',
  USER_COMPLETED_SURVEY: 'User completed survey',
  USER_COMPLETED_ASSIGNMENT: 'User completed assignment',
  INSTRUCTOR_GRADING: 'Instructor grading',
  ADD_DISCUSSION: 'Add discussion',
  REPLY_DISCUSSION: 'Reply discussion',
};

export const NOTIFICATION_DATA = {
  user_email: 'user_email',
  user_fullName: 'user_fullName',
  user_firstName: 'user_firstName',
  user_lastName: 'user_lastName',
  site_name: 'site_name',
  site_url: 'site_url',
  admin_email: 'admin_email',
  admin_name: 'admin_name',
  course_name: 'course_name',
  course_url: 'course_url',
  unit_url: 'unit_url',
  event_name: 'event_name',
  course_grading: 'course_grading',
  custom_link: 'custom_link',
  custom_data: 'custom_data',
};

export const LOCATION_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  DELETED: 'DELETED',
};

export const OPTION_EVENT_USER = {
  REGISTRY: 'REGISTRY',
  ALL: 'ALL',
  CUSTOM: 'CUSTOM',
  COURSE_USER_GROUP: 'COURSE_USER_GROUP',
};

export const ASSIGNMENT_STATUS_LABEL = {
  COMPLETED: 'Completed',
  RESUBMIT: 'Re-submit',
  PENDING: 'Pending',
  FAILED: 'Failed',
  DELETED: 'Deleted',
  RESET: 'Reset',
  GRADED: 'Graded',
  INCOMPLETED: 'Incompleted',
};
export const ASSIGNMENT_STATUS_LABEL_TEST = {
  GRADED: 'Graded',
  COMPLETED: 'Completed',
  RESUBMIT: 'Re-submit',
  PENDING: 'Pending',
  NOTPASSED: 'Not Passed',
  DELETED: 'Deleted',
  RESET: 'Reset',
  REATTEMPT: 'Re-Attempt',
  WAITING_FOR_REVIEW: 'Pending for Review',
};
export const ASSIGNMENT_STATUS_COLOR = {
  COMPLETED: '#28c76f',
  RESUBMIT: '#0275d8',
  PENDING: '#E59819',
  NOTPASSED: '#f78888',
  DELETED: '#f78888',
  RESET: '#0275d8',
  GRADED: '#28c76f',
};

export const SOCKET_CHAT_EVENT = {
  MESSAGE: 'MESSAGE',
  USER_ONLINE_STATE_CHANGE: 'USER_ONLINE_STATE_CHANGE',
  USER_UNREAD_MESSAGE_NUM: 'USER_UNREAD_MESSAGE_NUM',
  GROUP_UNREAD_MESSAGE_NUM: 'GROUP_UNREAD_MESSAGE_NUM',
  GROUP_CHAT_UPDATE: 'GROUP_CHAT_UPDATE',
};

export const TIME_SELECT_LOGIN = {
  HOUR: 'HOUR',
  FOURHOURS: 'FOURHOURS',
  TODAY: 'TODAY',
  THREEDAY: 'THREEDAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
};

export const CLASS_TYPE = [
  { value: 'PHYSICAL', label: 'Physical' },
  { value: 'LIVE', label: 'Online' },
];
export const CLASSES_TYPE = [
  { value: 'CLASSROOM', label: 'Physical Class' },
  { value: 'LIVESTREAMING', label: 'Live Class' },
  { value: 'MSTEAMS_MEETING', label: 'MSTeams Meeting' },
];
export const ROLE = [
  { value: 'INSTRUCTOR', label: 'Instructor' },
  { value: 'MARKING', label: 'Marking' },
  { value: 'ASSIST', label: 'Teaching Assist' },
];

export const LUNCH_TIME = [
  { value: '0.5', label: '0.5 Hour' },
  { value: '1', label: '1 Hour' },
  { value: '0', label: 'No Lunch' },
];

export const TIME_SELECT_LOGIN_LABEL = {
  HOUR: 'Last 1 hour',
  FOURHOURS: 'Last 4 hours',
  TODAY: 'Today',
  THREEDAY: 'Last 3 days',
  WEEK: '1 week',
  MONTH: 'Last month',
};

export const COLOR_TAG = {
  LOGIN: 'success',
  ADD: 'warning',
  DELETE: 'danger',
  CREATE: 'success',
  UPDATE: 'info',
  REMOVE: 'danger',
  PASSED: 'success',
  // status notification
  PENDING: 'custom-Pending',
  COMPLETED: 'custom-Completed',
  FAILED: 'custom-Failed',
  DELIVERED: 'custom-Delivered',
  DROPPED: 'custom-Dropped',
  DEFERRED: 'custom-Deferred',
  BOUNCE: 'custom-Bounce',
  BLOCKED: 'custom-Blocked',
  OPEN: 'custom-Open',
  CLICK: 'custom-Click',
  SPAM_REPORT: 'custom-Spam',
};

// -----------------------
// OPTION SELECT

export const LEARNING_HOURS_TYPE = [
  { value: true, label: 'Mins' },
  { value: false, label: 'Hrs' },
];
export const SESSION_HOURS_TYPE = [
  { value: 'm', label: 'Minutes' },
  { value: 'h', label: 'Hours' },
  { value: 'd', label: 'Days' },
  { value: 'w', label: 'Weeks' },
];

export const STATUS_OPTIONS = [
  { value: '', label: 'All status', select: false },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'INACTIVE', label: 'Inactive' },
];
export const GREAT_BOOK_APPROVAL = [
  { value: 'APPROVED', label: 'Approved' },
  { value: 'PENDING', label: 'Pending' },
];
export const SYNC_STATUS = [
  { value: 'SYNC_LMS', label: 'Sync Lms' },
  { value: 'SYNC_EMS', label: 'Sync Ems' },
];
export const GENDER_OPTIONS = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'Other', label: 'Other' },
];
export const LEARNER_STATUS_OPTIONS = [
  { value: 'ACTIVE', label: 'Not Yet Started' },
  { value: 'IN_PROGRESS', label: 'In-progress' },
  { value: 'COMPLETED', label: 'Completed' },
];

export const LEARNER_STATUS_Value = {
  ACTIVE: { value: 'ACTIVE', label: 'Not Yet Started' },
  IN_PROGRESS: { value: 'IN_PROGRESS', label: 'In-progress' },
  COMPLETED: { value: 'COMPLETED', label: 'Completed' },
  DELETED: { value: 'DELETED', label: 'Deleted' },
};

export const STATUS_LIVE_OPTIONS = [
  { value: '', label: 'All status live', select: true },
  { value: 'ONLINE', label: 'Online' },
  { value: 'OFFLINE', label: 'Offline' },
];
export const SATFF_REQUEST_ROLE = [
  { value: 'LEARNER', label: 'Learner' },
  { value: 'INSTRUCTOR', label: 'Instructor' },
];

const renderLastOnlineOptions = () => {
  const result = Object.keys(TIME_SELECT_LOGIN).map((key) => ({
    value: key,
    label: TIME_SELECT_LOGIN_LABEL[key],
  }));
  result.unshift({ value: '', label: 'All last online', select: true });
  return result;
};

export const LAST_ONLINE_OPTIONS = renderLastOnlineOptions();

// ----------------------
// PLACEHOLDER SELECT
export const PLACEHOLDER = {
  event: 'Event',
};

// -----------------------
export const ERROR_PERMISSION = {
  data: 'Permission denied',
  status: 401,
};

// work shop days
export const dayNamesLocal = [
  { name: 'Sunday', checked: false, id: 0, defaultChecked: false },
  { name: 'Monday', checked: false, id: 1, defaultChecked: false },
  { name: 'Tuesday', checked: false, id: 2, defaultChecked: false },
  { name: 'Wednesday', checked: false, id: 3, defaultChecked: false },
  { name: 'Thursday', checked: false, id: 4, defaultChecked: false },
  { name: 'Friday', checked: false, id: 5, defaultChecked: false },
  { name: 'Saturday', checked: false, id: 6, defaultChecked: false },
];

// work shop days fornitly
export const dayNamesLocal1 = [
  { name: 'Sunday', checked: false, id: 0, defaultChecked: false },
  { name: 'Monday', checked: false, id: 1, defaultChecked: false },
  { name: 'Tuesday', checked: false, id: 2, defaultChecked: false },
  { name: 'Wednesday', checked: false, id: 3, defaultChecked: false },
  { name: 'Thursday', checked: false, id: 4, defaultChecked: false },
  { name: 'Friday', checked: false, id: 5, defaultChecked: false },
  { name: 'Saturday', checked: false, id: 6, defaultChecked: false },
];

// work shop time slot
export const timeSlotLocal = [
  {
    id: 1,
    begin: 8,
    end: 9,
    fromlabel: '08.00 am',
    toLabel: '09.00 am',
    label: '08.00 am - 09.00 am',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 2,
    begin: 9,
    end: 10,
    fromlabel: '09.00 am',
    toLabel: '10.00 am',
    label: '09.00 am - 10.00 am',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 3,
    begin: 10,
    end: 11,
    fromlabel: '10.00 am',
    toLabel: '11.00 am',
    label: '10.00 am - 11.00 am',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 4,
    begin: 11,
    end: 12,
    fromlabel: '11.00 am',
    toLabel: '12.00 pm',
    label: '11.00 am - 12.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 5,
    begin: 12,
    end: 13,
    fromlabel: '12.00 pm',
    toLabel: '01.00 pm',
    label: '12.00 pm - 01.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 6,
    begin: 13,
    end: 14,
    fromlabel: '01.00 pm',
    toLabel: '02.00 pm',
    label: '01.00 pm - 02.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 7,
    begin: 14,
    end: 15,
    fromlabel: '02.00 pm',
    toLabel: '03.00 pm',
    label: '02.00 pm - 03.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 8,
    begin: 15,
    end: 16,
    fromlabel: '03.00 pm',
    toLabel: '04.00 pm',
    label: '03.00 pm - 04.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 9,
    begin: 16,
    end: 17,
    fromlabel: '04.00 pm',
    toLabel: '05.00 pm',
    label: '04.00 pm - 05.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 10,
    begin: 17,
    end: 18,
    fromlabel: '05.00 pm',
    toLabel: '06.00 pm',
    label: '05.00 pm - 06.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 11,
    begin: 18,
    end: 19,
    fromlabel: '06.00 pm',
    toLabel: '07.00 pm',
    label: '06.00 pm - 07.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 12,
    begin: 19,
    end: 20,
    fromlabel: '07.00 pm',
    toLabel: '08.00 pm',
    label: '07.00 pm - 08.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
];

export const timeSlotLocal1 = [
  {
    id: 1,
    begin: 8,
    end: 9,
    fromlabel: '08.00 am',
    toLabel: '09.00 am',
    label: '08.00 am - 09.00 am',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 2,
    begin: 9,
    end: 10,
    fromlabel: '09.00 am',
    toLabel: '10.00 am',
    label: '09.00 am - 10.00 am',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 3,
    begin: 10,
    end: 11,
    fromlabel: '10.00 am',
    toLabel: '11.00 am',
    label: '10.00 am - 11.00 am',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 4,
    begin: 11,
    end: 12,
    fromlabel: '11.00 am',
    toLabel: '12.00 pm',
    label: '11.00 am - 12.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 5,
    begin: 12,
    end: 13,
    fromlabel: '12.00 pm',
    toLabel: '01.00 pm',
    label: '12.00 pm - 01.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 6,
    begin: 13,
    end: 14,
    fromlabel: '01.00 pm',
    toLabel: '02.00 pm',
    label: '01.00 pm - 02.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 7,
    begin: 14,
    end: 15,
    fromlabel: '02.00 pm',
    toLabel: '03.00 pm',
    label: '02.00 pm - 03.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 8,
    begin: 15,
    end: 16,
    fromlabel: '03.00 pm',
    toLabel: '04.00 pm',
    label: '03.00 pm - 04.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 9,
    begin: 16,
    end: 17,
    fromlabel: '04.00 pm',
    toLabel: '05.00 pm',
    label: '04.00 pm - 05.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 10,
    begin: 17,
    end: 18,
    fromlabel: '05.00 pm',
    toLabel: '06.00 pm',
    label: '05.00 pm - 06.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 11,
    begin: 18,
    end: 19,
    fromlabel: '06.00 pm',
    toLabel: '07.00 pm',
    label: '06.00 pm - 07.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
  {
    id: 12,
    begin: 19,
    end: 20,
    fromlabel: '07.00 pm',
    toLabel: '08.00 pm',
    label: '07.00 pm - 08.00 pm',
    checked: false,
    status: false,
    defaultChecked: false,
  },
];

export const Comments = [
  {
    id: 1,
    logo: '/images/review1.jpg',
    name: 'Shuaiyu Shen',
    rating: 3,
    about:
      'ChampsLMS learning platform made my kid’s education more productive by closing learning gaps sooner and accelerating progress. It really helped a lot to make my child’s education accessible anytime anywhere. Thanks to the awesome ChampsLMS!',
  },
  {
    id: 2,
    logo: '/images/review2.jpg',
    name: 'Amy Liu',
    rating: 4,
    about:
      'My son is now able to access a wide range of courses that he needs to study as per the schedule made by him. ChampsLMS made my child learning more simple and energetic. I’m happy now for transforming him more enthusiastic.',
  },
  {
    id: 3,
    logo: '/images/review3.jpg',
    name: 'Mike Levy',
    rating: 4,
    about:
      'The ChampsLMS learning system is very user-friendly and it imperatively enhanced the present training process. The thing that makes it interesting is customer service, which takes time to sit with a client and assist them with their requirements. ',
  },
  {
    id: 4,
    logo: '/images/review4.jpg',
    name: 'Yang Cao',
    rating: 3,
    about:
      'ChampsLMS has been an outstanding in handling and developing an online personalized learning course for helping students. They are highly responsive and helpful and is highly professional in responding to feedback.',
  },
  {
    id: 5,
    logo: '/images/review5.jpg',
    name: 'Will Carroll',
    rating: 3,
    about:
      'After using ChampsLMS, We have seen a substantial reduction in our employee training costs as compared to classroom training. The employee training has become far more consistent and personalized, which in turn has helped in empowering employees with the necessary tools to effectively achieve their organizational goals.',
  },
  {
    id: 6,
    logo: '/images/review6.jpg',
    name: 'Craig Watts',
    rating: 5,
    about:
      'After switching to ChampsLMS, Our Educational institution has received tremendous responses from its trainees on ease of access and usage. They love the self-paced program format and the fact that their virtual sessions, surveys, quizzes, and recorded sessions are now available in one place without any glitches just adds to the whole experience.',
  },
];

export const Instructor = [
  {
    id: 1,
    logo: '/images/ins1.png',
    name: 'Lorraine Chao',
    books: 26,
    student: 76,
    about:
      'ChampsLMS learning platform made my kid’s education more productive by closing learning gaps sooner and accelerating progress. It really helped a lot to make my child’s education accessible anytime anywhere. Thanks to the awesome ChampsLMS!',
  },
  {
    id: 2,
    logo: '/images/ins2.png',
    name: 'Carla Taylor',
    books: 40,
    student: 86,
    about:
      'My son is now able to access a wide range of courses that he needs to study as per the schedule made by him. ChampsLMS made my child learning more simple and energetic. I’m happy now for transforming him more enthusiastic.',
  },
  {
    id: 3,
    logo: '/images/ins3.png',
    name: 'Anna Shirley',
    books: 36,
    student: 66,
    about:
      'The ChampsLMS learning system is very user-friendly and it imperatively enhanced the present training process. The thing that makes it interesting is customer service, which takes time to sit with a client and assist them with their requirements. ',
  },
  {
    id: 4,
    logo: '/images/ins4.png',
    name: 'Dave Lessing',
    books: 56,
    student: 96,
    about:
      'ChampsLMS has been an outstanding in handling and developing an online personalized learning course for helping students. They are highly responsive and helpful and is highly professional in responding to feedback.',
  },
  {
    id: 5,
    logo: '/images/ins5.png',
    name: 'Hilary Green',
    books: 26,
    student: 76,
    about:
      'After using ChampsLMS, We have seen a substantial reduction in our employee training costs as compared to classroom training. The employee training has become far more consistent and personalized, which in turn has helped in empowering employees with the necessary tools to effectively achieve their organizational goals.',
  },
  {
    id: 6,
    logo: '/images/ins6.png',
    name: 'Kayla Phelps',
    books: 86,
    student: 236,
    about:
      'After switching to ChampsLMS, Our Educational institution has received tremendous responses from its trainees on ease of access and usage. They love the self-paced program format and the fact that their virtual sessions, surveys, quizzes, and recorded sessions are now available in one place without any glitches just adds to the whole experience.',
  },
  {
    id: 7,
    logo: '/images/ins7.png',
    name: 'Ge Zhang',
    books: 46,
    student: 96,
    about:
      'After switching to ChampsLMS, Our Educational institution has received tremendous responses from its trainees on ease of access and usage. They love the self-paced program format and the fact that their virtual sessions, surveys, quizzes, and recorded sessions are now available in one place without any glitches just adds to the whole experience.',
  },
  {
    id: 8,
    logo: '/images/ins8.png',
    name: 'Elle Lyu',
    books: 36,
    student: 76,
    about:
      'After switching to ChampsLMS, Our Educational institution has received tremendous responses from its trainees on ease of access and usage. They love the self-paced program format and the fact that their virtual sessions, surveys, quizzes, and recorded sessions are now available in one place without any glitches just adds to the whole experience.',
  },
  {
    id: 9,
    logo: '/images/ins9.png',
    name: 'Ashley Chu',
    books: 65,
    student: 96,
    about:
      'After switching to ChampsLMS, Our Educational institution has received tremendous responses from its trainees on ease of access and usage. They love the self-paced program format and the fact that their virtual sessions, surveys, quizzes, and recorded sessions are now available in one place without any glitches just adds to the whole experience.',
  },
];
export const userRoutePath = [
  '/users',
  '/users/create',
  '/users/edit',
  '/users/[id]/edit',
];
export const usertypeRoutePath = [
  '/user-types',
  '/user-types/create',
  '/user-types/[id]/edit',
];
export const userGroupRoutePath = [
  '/group',
  '/group/create',
  '/group/[id]/edit',
];
export const courseGridRoutePath = [
  '/course/courseGrid',
  '/course/create',
  '/course/[slug]/edit',
];
export const intakeRoutePath = [
  '/intakes',
  '/intakes/create',
  '/intakes/[slug]',
  '/intakes/intakeGrid',
  '/intakes/intake-grid',
  '/homes/intake',
  '/homes/intake/intakeGridcard',
];

export const homeRoutePath = ['/lms-user/home', '/home', '/homeCms'];
export const dashboardRoutePath = ['/'];
export const courseRoutePath = [
  '/course',
  // '/course/[slug]',
  '/homes/course',
  // '/homes/course/[slug]',
];
export const workshopRouthPath = [
  '/homes/workshop',
  '/homes/workshop/view',
  '/course/[slug]/course-workshop',
  '/course/[slug]/course-ws-create',
  '/course/[slug]/course-ws-view',
  '/course/[slug]/course-ws-edit',
  '/workshop',
  '/workshop/create',
  '/workshop/view',
  '/workshop/edit',
  '/workshop/workshopCard',
];
export const centerRouthPath = [
  '/centre',
  '/centre/addcentre',
  '/centre/addcentres',
  '/centre/editCentre',
];
export const categoryRouthPath = [
  '/category',
  '/category/create',
  '/category/[id]/edit',
];
export const cmsPagesRouthPath = [
  '/lms-user/cmsBlog',
  '/lms-user/cmsBlog/testimonial',
  '/lms-user/cmsBlog/edit',
  '/lms-user/cmsBlog/view',
];
export const myTimesheetRouthPath = [
  '/timesheet/mytimesheet',
  '/timesheet/mytimesheet/view',
  '/timesheet/mytimesheet/addbank',
];
export const scheduleRouthPath = [
  '/timesheet/schedule',
  '/timesheet/schedule/addschedule',
  '/timesheet/schedule/view',
  '/timesheet/schedule/editschedule',
  '/timesheet/schedule/calenderview',
];
export const myScheduleRouthPath = [
  '/timesheet/myschedule',
  '/timesheet/myschedule/view',
];
export const approveRouthPath = [
  '/timesheet/approve',
  '/timesheet/approve/view',
  '/timesheet/approve/edit',
];
export const manageTimesheetRouthPath = [
  '/timesheet/managetimesheet',
  '/timesheet/managetimesheet/edit',
  '/timesheet/managetimesheet/view',
  '/timesheet/addtimesheet',
  '/timesheet/addtimesheet/view',
];
export const notificationRouthPath = [
  '/notification',
  '/notification/[id]/edit',
  '/notification/create',
  '/notification/history',
];
export const announcementRouthPath = [
  '/announcement',
  '/announcement/view',
  '/announcement/create',
];
export const badgeRouthPath = [
  '/Badge',
  '/Badge/create',
  '/Badge/badge',
  '/Badge/create/addType',
  '/Badge/modalBadges',
];
export const certificateRouthPath = [
  '/certificate',
  '/certificate/template-create',
  '/certificate/template-create/[id]/generateCertificate',
  '/course/[slug]/certificate',
  '/certificate/userCertificate',
];
export const userReportRouthPath = ['/reports/users', '/reports/users/[id]'];
export const courseReportRouthPath = [
  '/reports/courses',
  '/reports/courses/[slug]',
];
export const testReportRouthPath = ['/reports/tests', '/reports/tests/[id]'];
export const surveyReportRouthPath = [
  '/reports/surveys',
  '/reports/surveys/[id]',
];
export const assignmentReportRouthPath = [
  '/reports/assignments',
  '/reports/assignments/[id]',
];
export const scormReportRouthPath = ['/reports/scorm', '/reports/scorm/[id]'];
export const certificateReportRouthPath = ['/certificate/certificateReport'];
export const myLearningPath = ['/homes/myLearning'];
export const noRecord = 'No Records Found';

export const indiaPhoneCode = '+91';
export const singaporePhoneCode = '+65';
export const australiaPhoneCode = '+61';
export const indiaCurrencyCode = 'IN';
export const singaporeCurrencyCode = 'SG';
export const australiaCurrencyCode = 'AU';

export const WORK_SHOP_ITEM = {
  ONETOONE: 'ONE_TO_ONE',
  ONETOMANY: 'ONE_TO_MANY',
  modeonline: 'ONLINE',
  modephysical: 'PHYSICAL',
  TODAY: 'TODAY',
  WEEK: 'WEEKLY',
  FORTNIGHTLY: 'FORTNIGHTLY',
};

export const badgeTypeStatic = [
  {
    label: 'Login',
    value: {
      login: true,
      interval: true,
      regristration: false,
      countBased: false,
      course: false,
      intake: false,
      test: false,
      assignment: false,
      LiveClasses: false,
      physicalClasses: false,
      complete: false,
      completeCount: false,
      action: [],
      purchaseAmount: false,
    },
  },
  {
    label: 'Registration',
    value: {
      login: false,
      interval: false,
      regristration: true,
      countBased: false,
      course: false,
      intake: false,
      test: false,
      assignment: false,
      LiveClasses: false,
      physicalClasses: false,
      complete: false,
      completeCount: false,
      action: [],
      purchaseAmount: false,
    },
  },
  {
    label: 'Purchase Amount',
    value: {
      login: false,
      interval: false,
      regristration: false,
      countBased: false,
      course: false,
      intake: false,
      test: false,
      assignment: false,
      LiveClasses: false,
      physicalClasses: false,
      complete: false,
      completeCount: false,
      action: [],
      purchaseAmount: true,
    },
  },
  {
    label: 'Course',
    value: {
      login: false,
      interval: false,
      regristration: false,
      countBased: true,
      course: true,
      intake: false,
      test: false,
      assignment: false,
      LiveClasses: false,
      physicalClasses: false,
      complete: true,
      completeCount: true,
      action: ['IN_PROGRESS', 'COMPLETED'],
      purchaseAmount: false,
    },
  },
  {
    label: 'Lessons',
    value: {
      login: false,
      interval: false,
      regristration: false,
      countBased: true,
      course: true,
      intake: true,
      complete: true,
      completeCount: true,
      lessonType: true,
      action: ['COMPLETED'],
      purchaseAmount: false,
    },
  },
  {
    label: 'Classes',
    value: {
      login: false,
      interval: false,
      regristration: false,
      countBased: true,
      course: true,
      intake: true,
      test: false,
      assignment: false,
      LiveClasses: false,
      physicalClasses: false,
      complete: true,
      completeCount: true,
      action: ['IN_PROGRESS', 'COMPLETED'],
      purchaseAmount: false,
    },
  },
];

export const LESSON_ACTIONTYPE = new Map([
  ['LIVESTREAMING', ['ATTENDED', 'ATTENDANCE APPROVED']],
  ['MSTEAMS_MEETING', ['ATTENDED', 'ATTENDANCE APPROVED']],
  ['CLASSROOM', ['ATTENDANCE APPROVED']],
  ['TEST', ['ATTENDED', 'GRADED', 'COMPLETED']],
  ['ASSIGNMENT', ['ATTENDED', 'GRADED']],
]);

export const colorTheme = [
  { label: 'green', value: '#28a745', cssValue: 'green-clr-btn' },
  { label: 'orange', value: '#eb6709', cssValue: 'orange-clr-btn' },
  { label: 'pink', value: '#ef0677', cssValue: 'pink-clr-btn' },
  { label: 'magenta', value: '#940a6f', cssValue: 'magenta-clr-btn' },
  { label: 'purple', value: '#9463f7', cssValue: 'purple-clr-btn' },
  { label: 'teal', value: '#85494b', cssValue: 'teal-clr-btn' },
  { label: 'blue', value: '#007bff', cssValue: 'blue-clr-btn' },
  { label: 'brown', value: '#bb8573', cssValue: 'brown-clr-btn' },
  { label: 'yellow', value: '#FCB900', cssValue: 'yellow-clr-btn' },
];

// Question Type
export const QUESTION_TYPE_OPTION = [
  { value: '', label: 'All Type', select: true },
  { value: 'MTC', label: 'Multiple Choice' },
  { value: 'FILLTHEGAP', label: 'Fill the gap' },
  { value: 'FILLINTHEBLANK', label: 'Fill in the blank' },
  { value: 'ORDERING', label: 'Ordering' },
  { value: 'DRAGDROP', label: 'Dragdrop' },
  { value: 'FREETEXT', label: 'Freetext' },
  // { value: 'RANDOMIZED', label: 'Randomized' },
];

export const QUESTION_TYPE_OPTION_SURVEY = [
  { value: '', label: 'All Type', select: true },
  { value: 'MTC', label: 'Multiple Choice' },
  { value: 'FREETEXT', label: 'Freetext' },
  { value: 'RATING', label: 'Rating' },
  { value: 'SCALING', label: 'Scaling' },
];

export const FILE_SIZE_CONFIGURATION = [
  // {
  //   label: 'Max Submission Count Per Assignment',
  //   name: 'submissionLimit',
  //   value: 'SUBMISSION',
  //   answer: 1,
  //   Max Upload Size
  // },
  {
    label: 'Audio',
    name: 'audioMaxSize',
    value: 'AUDIO',
    answer: 1,
  },
  {
    label: 'Video',
    name: 'videoMaxSize',
    value: 'VIDEO',
    answer: 1,
  },
  {
    label: 'Presentation',
    name: 'presentationMaxSize',
    value: 'DOCUMENT',
    answer: 1,
  },
  {
    label: 'Scorm',
    name: 'scormMaxSize',
    value: 'SCORM',
    answer: 1,
  },
  {
    label: 'Files',
    name: 'fileMaxSize',
    value: 'FILES',
    answer: 1,
  },
  {
    label: 'Site Image',
    name: 'avatarMaxSize',
    value: 'AVATAR',
    answer: 1,
  },
  {
    label: 'Chat Message',
    name: 'chatMaxSize',
    value: 'CHATMESSAGE',
    answer: 1,
  },
  {
    label: 'Certificate Template',
    name: 'certificateMaxSize',
    value: 'CERTIFICATE',
    answer: 1,
  },
];

export const DEFAULTCONTENTDATA = {
  title: 'Embark on Your Journey with Us!',
  description: `We offer phenomenal learning opportunities and learning
                  experiences to educators of K-12 levels, higher education
                  (Diploma, Degree, and Masters), and diverse learning
                  programmes including career conversions, corporate training,
                  professional certification, and micro-learning programmes. Our
                  digital learning platform serves the best for all learners to
                  achieve their ideal goals quicker.`,
  logo: '/images/hero-banner.svg',
};

export const pathValues = [
  '/lms-user/home',
  '/homeCms',
  '/course',
  '/homes/course',
  '/intakes/intakeGrid',
  '/intakes/intake-grid',
  '/homes/myLearning',
  '/homes/intake/',
];

export const slugbuttonData = [
  {
    label: 'INTAKE NAME',
    slug: '[INTAKE NAME]',
  },
  {
    label: 'COURSE NAME',
    slug: '[COURSE NAME]',
  },
  {
    label: 'LEARNER NAME',
    slug: '[LEARNER NAME]',
  },
  {
    label: 'DATE',
    slug: '[DATE]',
  },
  {
    label: 'INSTRUCTOR NAME',
    slug: '[INSTRUCTOR NAME]',
  },
];

export const certificateDimensions = [
  {
    label: '750 X 550',
    x: 750,
    y: 550,
  },
  {
    label: '640 X 480',
    x: 640,
    y: 480,
  },
  {
    label: '800 X 600',
    x: 800,
    y: 600,
  },
  {
    label: '600 X 800',
    x: 600,
    y: 800,
  },
  {
    label: '600 X 600',
    x: 600,
    y: 600,
  },
];

export const uiConfig = {
  GROUP: {
    styles: {
      className: '',
      cssVar: {
        bg: '#f2fefa',
        border_blr: ' #589281',
        icon_clr: 'rgb(82 146 130)',
      },
    },
  },
  UNIT: {
    styles: {
      className: '',
      cssVar: {
        bg: '#fff6ee',
        border_blr: ' #febc82',
        icon_clr: 'rgb(255, 162, 81)',
      },
    },
  },
  LESSON: {
    styles: {
      className: '',
      cssVar: {
        bg: '#f8f8f8',
        border_blr: '#f8f8f8',
        icon_clr: 'rgb(142, 150, 170)',
      },
    },
  },
  SECTION: {
    styles: {
      className: '',
      cssVar: {
        bg: '#ffeff2',
        border_blr: '#fe8fa3',
        icon_clr: 'rgb(255, 67, 101)',
      },
    },
  },
  SUB_SECTION: {
    styles: {
      className: '',
      cssVar: {
        bg: '#f3f8ff',
        border_blr: '#81b3ff',
        icon_clr: 'rgb(129, 179, 255)',
      },
    },
  },
};

export const DETAILPAGE_CARD_TYPE = {
  GROUP: 'isGroup',
  UNIT: 'isUnit',
  SECTION: 'isSection',
  SUB_SECTION: 'isSubSection',
};

export const OPTION_ICON = [
  {
    name: 'ADDUNIT',
    label: 'Add Unit',
    show: [UNIT_TYPE.GROUP],
    order: 1,
  },
  {
    name: 'ADDLESSON',
    label: 'Add Lesson',
    show: [UNIT_TYPE.UNIT, UNIT_TYPE.SECTION, UNIT_TYPE.SUB_SECTION],
    order: 2,
  },
  {
    name: 'ADDSECTION',
    label: 'Add Section',
    show: [UNIT_TYPE.UNIT],
    order: 3,
  },
  {
    name: 'ADDSUBSECTION',
    label: 'Add SubSection',
    show: [UNIT_TYPE.SECTION],
    order: 4,
  },
  {
    name: 'ADD',
    label: 'Add',
    show: [UNIT_TYPE.LESSON],
    order: 5,
  },
  {
    name: 'EDIT',
    label: 'Edit',
    show: [UNIT_TYPE.GROUP, UNIT_TYPE.UNIT, UNIT_TYPE.LESSON],
    order: 6,
  },
  {
    name: 'CHANGE_NAME',
    label: 'Change Name',
    show: [
      UNIT_TYPE.SECTION,
      UNIT_TYPE.SUBSECTION,
      UNIT_TYPE.SUB_SECTION,
      UNIT_TYPE.LESSON,
    ],
    order: 7,
  },
  {
    name: 'DELETE',
    label: 'Delete',
    show: [
      UNIT_TYPE.GROUP,
      UNIT_TYPE.UNIT,
      UNIT_TYPE.SECTION,
      UNIT_TYPE.SUB_SECTION,
      UNIT_TYPE.LESSON,
    ],
    order: 8,
  },
  {
    name: 'CLONE',
    label: 'Clone',
    show: [
      UNIT_TYPE.GROUP,
      UNIT_TYPE.UNIT,
      UNIT_TYPE.SECTION,
      UNIT_TYPE.SUB_SECTION,
      UNIT_TYPE.LESSON,
    ],
    order: 9,
  },

  {
    name: 'VIEW',
    label: 'View',
    show: [UNIT_TYPE.LESSON],
    order: 10,
  },
  {
    name: 'SUBMISSION',
    label: 'Submission',
    show: [UNIT_TYPE.LESSON],
    order: 11,
  },
  {
    name: 'ACTIVE_STATUS',
    label: 'Active',
    show: [
      UNIT_TYPE.GROUP,
      UNIT_TYPE.UNIT,
      UNIT_TYPE.SECTION,
      UNIT_TYPE.SUB_SECTION,
      UNIT_TYPE.LESSON,
    ],
    order: 12,
  },
  {
    name: 'END_SESSION',
    label: 'End Session',
    show: [UNIT_TYPE.LESSON],
    order: 13,
  },
];

export const CONTENT_APPROVAL = {
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
  APPROVED: 'APPROVED',
  RESUBMIT: 'RESUBMIT',
};

export const NEXT_ARRAY_TYPE = {
  isIntake: 'data',
  GROUP: 'courseUnits',
  UNIT: 'sections',
  SECTION: 'subSections',
  UnitSection: 'sections',
  SectionSub: 'subSections',
};

export const CARD_TYPE = {
  GROUP: UNIT_TYPE.GROUP,
  courseUnits: UNIT_TYPE.UNIT,
  sections: UNIT_TYPE.SECTION,
  subSections: UNIT_TYPE.SUB_SECTION,
  lessons: 'default',
  UnitSection: UNIT_TYPE.UNIT,
  SectionSub: UNIT_TYPE.SECTION,
};

export const GENERATE_ID_FOR = [
  UNIT_TYPE.LIVESTREAMING,
  UNIT_TYPE.MSTEAMS_MEETING,
  UNIT_TYPE.ASSIGNMENT,
  UNIT_TYPE.TEST,
  UNIT_TYPE.CLASSROOM,
];

export const PARENT_TYPE = {
  GROUP: UNIT_TYPE.GROUP,
  UNIT: UNIT_TYPE.GROUP,
  SECTION: UNIT_TYPE.UNIT,
  SUB_SECTION: UNIT_TYPE.SECTION,
};

export const NEXT_ID_TO_PASS = (data) => {
  const id = {
    GROUP: data?.course,
    UNIT: data?.group,
    SECTION: data?.courseUnit,
    SUB_SECTION: data?.section,
  };
  return id[data?.type];
};

export const EMOJI_EXPRESSION = ['bad', 'notGood', 'notBad', 'neutral', 'good'];

export const restrictMethods = [
  { name: 'Disable Rigth Click', key: 'rigthClick' },
  { name: 'Disable F12', key: 'f12' },
  { name: 'Disable Ctrl Key', key: 'ctrlKey' },
  { name: 'Disable Download', key: 'download' },
];

export const returnTestType = [
  { name: 'Multiple Choice', key: 'MTC' },
  { name: 'Fill The Gap', key: 'FILLTHEGAP' },
  { name: 'Fill In The Blank', key: 'FILLINTHEBLANK' },
  { name: 'Ordering', key: 'ORDERING' },
  { name: 'Drag And Drop', key: 'DRAGDROP' },
  { name: 'Free Text', key: 'FREETEXT' },
];

export const NOTIFICATION_LABEL = {
  REGISTRY_ACCOUNT: 'UserRegistered',
  DELETE_ACCOUNT: 'AccountDeleted',
  CHANGE_PASSWORD_ACCOUNT: 'PasswordChanged',
  RESET_PASSWORD: 'PasswordReset',
  ADD_TO_INTAKE: 'WhenEnrollClasses',
  ADD_TO_EVENT: 'LiveOrPhysicalClassCreate',
  REMOVE_FROM_INTAKE: 'WhenUnEnrollClasses',
  REMOVE_FROM_EVENT: 'LiveOrPhysicalClassDelete',
  COURSE_DELETED: 'Course deleted',
  INTAKE_DELETED: 'Intake deleted',
  ANNOUNCEMENT_CREATED: 'Announcement created',
  UNIT_DELETED: 'LessonDeleted',
  UNIT_CREATED: 'LessonCreated',
  EVENT_STARTED: 'liveclass started',
  TEST_STARTED: 'Test started',
  USER_COMPLETED_COURSE: 'User completed course',
  USER_COMPLETED_TEST: 'User completed test',
  USER_COMPLETED_VIDEO: 'User completed video',
  USER_COMPLETED_AUDIO: 'User completed audio',
  USER_COMPLETED_SURVEY: 'User completed survey',
  USER_COMPLETED_FILES: 'User completed files',
  USER_COMPLETED_ASSIGNMENT: 'User completed assignment',
  USER_COMPLETED_SCORM: 'User completed scorm',
  INSTRUCTOR_GRADING: 'Instructor grading',
  ADD_DISCUSSION: 'discussion added',
  REPLY_DISCUSSION: 'Reply discussion',
  REPLY_COMMENT_DISCUSSION: 'Reply comment discussion',
  TWO_FACTOR_AUTHENTICATION: 'Two factor authentication',
  USER_COMPLETED_DOCUMENT: 'User completed document',
  USER_COMPLETED_IFRAME: 'User completed iframe',
  MARKED_ATTENDANCE: 'Marked attendance',
};

export const NOTIFICATION_NOTE = {
  newUserCreatedOrImported: ['New account is created / Registered / imported'],
  userDeleted: ['When the account deleted'],
  passwordChanged: ['When the password is changed'],
  forgotPassword: ['When a Forgot Password triggered'],
  addEnrollLearnerToClasses: ['When enrolling a learner in the classes'],
  removeUnenrollLearnerToClasses: [
    'When Unenrolling a learner from the classes',
  ],
  userCompletedClassSelfLearning: [
    'Rules and path',
    'When a learner completes the self learning, condition should be met.',
  ],
  liveClassCreatedAllUser: [
    'Live class create',
    `User type should be "All User"`,
  ],
  liveClassAddSomeUser: [
    'Live class create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing live lesson',
  ],
  liveClassCreateAlreadyUsersInclude: [
    'When enroll new user to already created live lesson',
  ],
  liveClassRemoveSomeUser: [
    `The user type should be "Some User"`,
    'When user remove from a live class lesson',
  ],
  liveLessonReminder: ['Notification trigger before live lesson start'],
  liveClassDeleted: [
    'Click the delete button on the Live class',
    'Live class will be deleted',
  ],
  liveClassRegister: [
    'Create Live Class',
    'enrolled learner',
    'When registering for a live class',
  ],
  liveClassUnRegister: [
    'Take already existing Live Class',
    'Unenrolled learner',
    'When unregistering from a live class',
  ],
  physicalClassCreatedAllUser: [
    'Create physical class',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  physicalClassAddSomeUser: [
    'Physical class create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing physical class',
  ],
  physicalClassRemoveSomeUser: [
    `The user type should be "Some User"`,
    'When user remove from a physical class lesson',
  ],
  physicalClassDeleted: [
    'Click the delete button on the physical class',
    ' physical class will be deleted',
  ],
  videoLessonsCreatedAllUser: [
    'Create Video class',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  videoLessonsAddSomeUser: [
    'Video lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Video lesson',
  ],
  videoLessonsRemoveSomeUser: [
    'When some users are removed from already created video lesson',
  ],
  videoLessonsDeleted: [
    'Click the delete button on the video lesson',
    'Video lesson will be deleted',
  ],
  audioLessonsCreatedAllUser: [
    'Create Audio lesson',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  audioLessonsAddSomeUser: [
    'Audio lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Audio lesson',
  ],
  audioLessonsRemoveSomeUser: [
    'When some users are removed from already created Audio lesson',
  ],
  audioLessonsDeleted: [
    'Click the delete button on the Audio lesson',
    'Audio lesson will be deleted',
  ],
  filesLessonsCreatedAllUser: [
    'Create Files lesson',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  filesLessonsAddSomeUser: [
    'Files lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Files lesson',
  ],
  filesLessonsRemoveSomeUser: [
    'When some users are removed from already created Files lesson',
  ],
  filesLessonsDeleted: ['Enrolled learner', 'When a files is deleted'],
  presentationLessonsCreatedAllUser: [
    'Create Presentation lesson',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  presentationLessonsAddSomeUser: [
    'Presentation lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Presentation lesson',
  ],
  presentationLessonsRemoveSomeUser: [
    'When some users are removed from already created Presentation lesson',
  ],
  presentationLessonsDeleted: [
    'Click the delete button on the Presentation lesson',
    'Presentation lesson will be deleted',
  ],
  scormLessonsCreatedAllUser: [
    'Create Scorm lesson',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  scormLessonsAddSomeUser: [
    'Scorm lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Scorm lesson',
  ],
  scormLessonsRemoveSomeUser: [
    'When some users are removed from already created Scorm lesson',
  ],
  scormLessonsDeleted: [
    'click the delete button on the Scorm lesson',
    'Scorm lesson will be deleted',
  ],
  contentLessonsCreatedAllUser: [
    'Create Content lesson',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  contentLessonsAddSomeUser: [
    'Content lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Content lesson',
  ],
  contentLessonsRemoveSomeUser: [
    'When some users are removed from already created Content lesson',
  ],
  contentLessonsDeleted: [
    'Click the delete button on the Survey lesson',
    'Survey lesson will be deleted',
  ],
  iframeLessonsCreatedAllUser: [
    'Create Iframe lesson',
    'Enrolled learne',
    `User type should be "All User"`,
  ],
  iframeLessonsAddSomeUser: [
    'Iframe lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Iframe lesson',
  ],
  iframeLessonRemoveSomeUser: [
    'When some users are removed from already created Iframe lesson',
  ],
  iframeLessonsDeleted: [
    'Click the delete button on the Iframe lesson',
    'Iframe lesson will be deleted',
  ],
  testLessonsCreatedAllUser: [
    'Create Test lesson',
    ' Enrolled learner',
    `User type should be "All User"`,
  ],
  testLessonsAddSomeUser: [
    'Files lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existingTests lesson',
  ],
  testLessonsRemoveSomeUser: [
    'When some users are removed from already created Test lesson',
  ],
  testLessonsDeleted: [
    'Click the delete button on the Test lesson',
    'Test lesson will be deleted',
  ],
  surveyLessonCreatedAllUser: [
    'Create Survey lesson',
    'Enrolled learner',
    `User type should be "All User`,
  ],
  surveyLessonAddSomeUser: [
    'Survey lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Survey lesson',
  ],
  surveyLessonRemoveSomeUser: [
    'When some users are removed from already created Survey lesson',
  ],
  surveyLessonDeleted: [
    'Click the delete button on the Survey lesson',
    'Survey lesson will be deleted',
  ],
  assignmentLessonCreatedAllUser: [
    'Create Assignment lesson',
    'Enrolled learner',
    `User type should be "All User"`,
  ],
  assignmentLessonAddSomeUser: [
    'Assignment lesson create',
    `The user type should be "Some User"`,
    'When a new leaner added to the existing Assignment lesson',
  ],
  assignmentLessonRemoveSomeUser: [
    'When some users are removed from already created Assignment lesson',
  ],
  assignmentLessonDeleted: [
    'Click the delete button on the Assignment lesson',
    'Assignment lesson will be deleted',
  ],
  userCompletedClassesAllUser: [
    'When all users complete the entire class lessons',
  ],
  userCompletedClassesCustomUser: [
    'When custom user complete the entire class lessons',
  ],
  lessonReminder: [
    'when learner not completed lesson or when learner class not yet start',
  ],
  learnerEnrolledInstructor: [
    'when learner enrolled in class notification trigger to instructor ',
  ],
  intakeDeleted: ['When an intake is deleted'],
  announcementCreated: ['When an announcement is created'],
  announcementDeleted: ['When an announcement is deleted'],
  liveClassStarted: ['When an live lesson is started'],
  userCompletedClass: ['When an user complete the entire class'],
  userCompletedTest: ['When an user complete the Test'],
  userFailedTest: ['When an user failed the Test'],
  userResetTest: ['When an user reset the Test'],
  userReattemptTest: ['When an user reattempt the Test'],
  userStartedTest: ['When an user started the Test'],
  userCompletedVideo: ['When an user complete the Video lesson'],
  userCompletedAudio: ['When an user complete the Audio lesson'],
  userCompletedSurvey: ['When an user complete the Survey'],
  userCompletedFiles: ['When an user complete the Files'],
  userCompletedAssignment: ['When an user complete the Assignment'],
  userCompletedSCORM: ['When an user complete the SCORM'],
  userCompletedPresentation: ['When an user complete the Presentation'],
  userCompletediFrame: ['When an user complete the iFrame'],
  instructorGrading: ['When an instructor grading the lesson'],
  discussionCreated: ['When a user creates a discussion'],
  replyingDiscussion: ['When a user replies to a discussion'],
  replyingCommentDiscussion: ['When replying to a comment in a discussion'],
  twoFactorAuthentication: ['When two-factor authentication is enabled'],
  attendanceMarking: ['When a Live class and ClassRoom Attendance Marking'],
  learningPathIncompleteReminder: [
    'When a user has an incomplete learning path',
  ],
  learningPathStageIncompleteReminder: [
    'When a user has incomplete stages in their learning path',
    'based on the template selected in the learning path reminder',
  ],
  learningPathEnrollment: [
    'When a user is successfully enrolled in a learning path',
  ],
  learningPathCompleted: [
    'When a user completes all stages within their assigned learning path',
  ],
  learningPathInsufficientCredit: [
    'When a user has insufficient credit to enroll in a learning path',
  ],
  learningPathStageAutoEnrollment: [
    'When a user is automatically enrolled in a new stage of their learning path(including auto-enrollment)',
  ],
  upgradeStaffTypeReminder: [
    'When a staff type is upgraded to a different staff type',
    'based on the template selected in the stafftype reminder',
  ],
  staffTypeUpgrade: ['When a stafftype is upgraded to a different staff type'],
  inSufficientCredit: ['Insufficient Credit to Enroll LearningPath'],
  learningPathStageCompleted: [
    'When a user has complete stages in their learning path',
  ],
  onboardingStaffRequestRejected: [
    'When Rejecting the Onboarding Staff Request',
  ],
  onboardingAccountSetupPending: ['When Pending the Onboarding Account Setup'],
  onboardingStaffRequestNotified: [
    'When Notifying the Onboarding Staff Request',
  ],
  onboardingPendingAcceptance: [
    'When User Setup Onboarding Requester Action Pending.',
  ],
  offboardingStaffRequestRejected: [
    'When Rejecting the Off-boarding Staff Request',
  ],
  offboardingStaffRequestAccepted: [
    'When Accepting the Off-boarding Staff Request',
  ],
  offboardingStaffRequestNotified: [
    'When Notifying the Off-boarding Staff Request Notified',
  ],
  offboardingPendingAcceptance: [
    'When Hr Aprrove the Form Off-boarding Requester Action Pending.',
  ],
  transferStaffRequestRejected: ['When Rejecting the Transfer Staff Request'],
  transferAccountSetupPending: [
    'When Pending the Transfer Staff Account Setup',
  ],
  transferStaffRequestNotified: [
    'When Notifying the Transfer Staff Request Notified',
  ],
  transferPendingAcceptance: [
    'When User Setup Transfer Staff Requester Action Pending.',
  ],
  staffRequestReSubmitted: ['When Staff Request Resubmitted'],
  staffRequestOnboarding: ['When Staff Request Onboarded'],
  microSoftAccountCreation: ['When Microsoft Account Creation'],
  staffRequestOffboarding: ['When Staff Request offboarded'],
  staffRequestTransferred: ['When Staff Request Transferred'],
};

export const NOTIFICATION_EVENT_LIST = {
  newUserCreatedOrImported: 'New User Create or Import',
  userDeleted: 'User Delete',
  passwordChanged: 'Password Changed',
  forgotPassword: 'Forgot Password',
  addEnrollLearnerToClasses: 'Add/Import/Enroll Learner to the Classes',
  removeUnenrollLearnerToClasses: 'Remove/Un Enroll Learner to the Classes',
  liveClassCreatedAllUser: 'Live Class Create All Users',
  liveClassCreateAlreadyUsersInclude: 'Live Class Already & Future Enroll User',
  liveClassAddSomeUser: 'Live Class Some Users Add ',
  liveClassRemoveSomeUser: 'Live Class Some Users Remove',
  liveClassDeleted: 'Live Class Delete',
  liveClassRegister: 'Live Class Register ',
  liveClassUnRegister: 'Live Class Un Register',
  physicalClassCreatedAllUser: 'Physical Class Create All Users',
  physicalClassAddSomeUser: 'Physical Class Some Users Add',
  physicalClassRemoveSomeUser: 'Physical Class Some Users Remove',
  physicalClassDeleted: 'Physical Class Delete',
  videoLessonsCreatedAllUser: 'Video Lesson Create All Users',
  videoLessonsAddSomeUser: 'Video Lesson Some Users Add',
  videoLessonsRemoveSomeUser: 'Video Lesson Some Users Remove',
  videoLessonsDeleted: 'Video Lesson Delete',
  audioLessonsCreatedAllUser: 'Audio Lesson Create All Users',
  audioLessonsAddSomeUser: 'Audio Lesson Some Users Add',
  audioLessonsRemoveSomeUser: 'Audio Lesson Some Users Remove',
  audioLessonsDeleted: 'Audio Lesson Delete',
  filesLessonsCreatedAllUser: 'Files Lesson Create All Users',
  filesLessonsAddSomeUser: 'Files Lesson Some Users Add',
  filesLessonsRemoveSomeUser: 'Files Lesson Some Users Remove',
  filesLessonsDeleted: 'Files Lesson Delete',
  presentationLessonsCreatedAllUser: 'Presentation Lessons Create All Users',
  presentationLessonsAddSomeUser: 'Presentation Lessons Some Users Add',
  presentationLessonsRemoveSomeUser: 'Presentation Lessons Some Users Remove',
  presentationLessonsDeleted: 'Presentation Lessons Delete',
  scormLessonsCreatedAllUser: 'SCORM Lessons Create All Users',
  scormLessonsAddSomeUser: 'SCORM Lessons Some Users Add',
  scormLessonsRemoveSomeUser: 'SCORM Lessons Some Users Remove',
  scormLessonsDeleted: 'SCORM Lessons Delete',
  contentLessonsCreatedAllUser: 'Content Lessons Create All Users',
  contentLessonsAddSomeUser: 'Content Lessons Some Users Add',
  contentLessonsRemoveSomeUser: 'Content Lessons Some Users Remove',
  contentLessonsDeleted: 'Content Lessons Delete',
  iframeLessonsCreatedAllUser: 'Iframe Lessons Create All Users',
  iframeLessonsAddSomeUser: 'Iframe Lessons Some Users Add',
  iframeLessonRemoveSomeUser: 'Iframe Lessons Some Users Remove',
  iframeLessonsDeleted: 'Iframe Lessons Delete',
  testLessonsCreatedAllUser: 'Test Lessons Create All Users',
  testLessonsAddSomeUser: 'Test Lessons Some Users Add',
  testLessonsRemoveSomeUser: 'Test Lessons Some Users Remove',
  testLessonsDeleted: 'Test Lessons Delete',
  surveyLessonCreatedAllUser: 'survey Lessons Create All Users',
  surveyLessonAddSomeUser: 'survey Lessons Some Users Add',
  surveyLessonRemoveSomeUser: 'survey Lessons Some Users Remove',
  surveyLessonDeleted: 'survey Lessons Delete',
  assignmentLessonCreatedAllUser: 'assignment Lessons Create All Users',
  assignmentLessonAddSomeUser: 'assignment Lessons Some Users Add',
  assignmentLessonRemoveSomeUser: 'assignment Lessons Some Users Remove',
  assignmentLessonDeleted: 'assignment Lessons Delete',
  userCompletedClassesAllUser: 'User Completed Classes Some Users',
  userCompletedClassesCustomUser: 'User Completed Classes All Users',
  userCompletedClassSelfLearning: 'User Completed Class self learning',
  intakeDeleted: 'Intake Deleted',
  announcementCreated: 'Announcement Created',
  announcementDeleted: 'Announcement Deleted',
  liveClassStarted: 'Live Class Started',
  userCompletedClass: 'User Completed Class',
  userCompletedTest: 'User Completed Test',
  userFailedTest: 'User Failed Test',
  userResetTest: 'User Reset Test',
  userReattemptTest: 'User Reattempt Test',
  userStartedTest: 'User Started Test',
  userCompletedVideo: 'User Completed Video',
  userCompletedAudio: 'User Completed Audio',
  userCompletedSurvey: 'User Completed Survey',
  userCompletedFiles: 'User Completed Files',
  userCompletedAssignment: 'User Completed Assignment',
  userCompletedSCORM: 'User Completed SCORM',
  userCompletedPresentation: 'User Completed Presentation',
  userCompletediFrame: 'User Completed iFrame',
  instructorGrading: 'Test and Assignment Grading',
  discussionCreated: 'Discussion Created',
  replyingDiscussion: 'Replying Discussion',
  replyingCommentDiscussion: 'Replying Comment Discussion',
  twoFactorAuthentication: 'Two Factor Authentication',
  attendanceMarking: 'Live class and ClassRoom Attendance Marking',
};

export let TIMES = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
};

export const SCHEDULER_TYPE = {
  Immediate: { value: 'Immediate', label: 'Immediate' },
  Scheduled: { value: 'Scheduled', label: 'Scheduled' },
};

export const DEFAULT_DURATION = '0.48';

export const DEFAULT_REMAINDER = 1;

export const BAR_COLORS = {
  100: '#43a047',
  95: '#43a047',
  90: '#52a85f',
  85: '#66bb6a',
  80: '#85c66b',
  75: '#a0d669',
  70: '#cddc39',
  65: '#ffeb3b',
  60: '#ffc107',
  55: '#ff9800',
  50: '#ff7043',
  45: '#ff5c4a',
  40: '#ff4c3b',
  35: '#ff3b2f',
  30: '#f44336',
  25: '#f03a32',
  20: '#ea332d',
  15: '#e82c28',
  10: '#e62a26',
  5: '#e53d35',
  0: '#e53935',
};
